import { gql } from "@apollo/client";

// Shared GraphQL fragments for portfolios.
//
// This module deliberately has NO app-level imports (no providers, no barrels)
// so it stays a leaf in the import graph. PORTFOLIO_BASIC_FIELDS used to live in
// useGetContactInfo.ts, which imports KeycloakProvider -> the `components` barrel
// -> UserMenu -> Wizard -> useGetPortfoliosWithProfileAndFigures, forming a
// circular dependency. When module evaluation order put useGetContactInfo first
// in that cycle, consumers read the fragment before its `const` initialized,
// throwing "Cannot access 'PORTFOLIO_BASIC_FIELDS' before initialization".
// Keeping the fragment here breaks that cycle.

//with 1 sub portfolio depth
export const PORTFOLIO_BASIC_FIELDS = gql`
  fragment PortfolioBasicFields on Portfolio {
    id
    name
    shortName
    status
    currency {
      securityCode
    }
    portfolios {
      id
      name
      status
      currency {
        securityCode
      }
      portfolios {
        id
        name
        status
        currency {
          securityCode
        }
      }
    }
  }
`;
